import { SystemError } from '../errors';
import type { AgentInputItem } from '../types';

export function assertNoCompactMetadata(
  items: AgentInputItem[],
  location: string = 'model input',
): void {
  for (const item of items) {
    if (!item || typeof item !== 'object') {
      continue;
    }
    const record = item as Record<string, unknown>;
    if (
      record.type === 'compact_boundary' ||
      record.type === 'compact_summary'
    ) {
      throw new SystemError(
        `Local compaction metadata leaked into ${location}. Compact records must be assembled into ordinary model messages before provider calls.`,
      );
    }
    if (
      record.type === 'compaction' ||
      (typeof record.summaryItemId === 'string' &&
        record.compactedRange &&
        typeof record.insertAfterItemId === 'string') ||
      (typeof record.boundaryId === 'string' &&
        typeof record.content === 'string' &&
        record.source)
    ) {
      throw new SystemError(
        `Unsupported compaction item leaked into ${location}. Provider inputs cannot contain compact metadata.`,
      );
    }
  }
}
